import { useSearchParams } from 'react-router';

import { AuthSplitLayout } from '@/components/layout/AuthSplitLayout';
import OrganizationSignupForm from '@/components/auth/OrganizationSignupForm';

const OrganizationSignupPage = () => {
  const [searchParams] = useSearchParams();

  const loginChallenge = searchParams.get('login_challenge') ?? undefined;

  return (
    <AuthSplitLayout>
      <OrganizationSignupForm loginChallenge={loginChallenge} />
    </AuthSplitLayout>
  );
};

export default OrganizationSignupPage;
